import { COLORS } from '@app/src/ui';
import React, { useCallback } from 'react';
import {
  Wrapper,
  Title,
  Subtitle,
  Discount,
  PriceTotal,
  Number,
  Decimal,
  PriceRegular,
  Separator,
  List,
  Item,
  Channel,
  HighLights,
  ListHigh,
  ItemHigh,
  Count,
  ButtonContract
} from './styled';

interface Props {
  title: string;
  isRecommend: boolean;
  subtitle: string;
  discount: number;
  price: number;
  priceRegular: number;
  handleClick: Function;
  detailAds: Array<any>;
  detailExtra: Array<any>;
  isLoading?: boolean;
  duration: number;
}

export const CardPackage: React.FC<Props> = ({
  title,
  isRecommend,
  subtitle,
  discount,
  price,
  priceRegular,
  handleClick,
  detailAds,
  detailExtra,
  isLoading,
  duration
}) => {
  const getNumberFromPrice: Function  = useCallback(() => {
    return Math.trunc(price);
  }, [price]);

  const getDecimalFromPrice: Function  = useCallback(() => {
    const result = price - Math.floor(price);

    return result.toFixed(2).substring(1) ;
  }, [price]);

  return(
  <Wrapper isRecommend={isRecommend}>
    <Title>{title}</Title>
    <Subtitle>{subtitle}</Subtitle>
    <Discount>Ahorra {discount}%</Discount>
    <PriceTotal>
      <Number>S/{getNumberFromPrice()}</Number><Decimal>{getDecimalFromPrice()}</Decimal> + igv
    </PriceTotal>
    <PriceRegular>Precio regular S/{priceRegular}</PriceRegular>
    <Separator/>
    <HighLights>{duration === 1 ? '1 mes' : `${duration} meses`} de duración</HighLights>
    <List>
      {
        detailAds && detailAds.length > 0 && detailAds.map((item, index) => (
          <Item key={index}>{item.quantity} {item.description}{item.publication && <Channel> ({item.publication})</Channel>}</Item>
        ))
      }
    </List>
    {
      detailExtra && detailExtra.length > 0 &&
        <React.Fragment>
          <HighLights>Destaques incluidos</HighLights>
          <ListHigh>
          {
            detailExtra.map((item, index) => (
              <ItemHigh key={index}>{item.description}: <Count>{item.quantity}</Count></ItemHigh>
            ))
          }
          </ListHigh>
        </React.Fragment>
    }
    <ButtonContract
      background={COLORS.BLUE_LINK}
      width={200}
      color="#fff"
      handleClick={handleClick}
      loading={isLoading}
    >Contratar</ButtonContract>
  </Wrapper>
)};